<template>
  <footer>
    <div class="footer__container">
      <div class="footer__copyright">
        © 2022 Jaked by MIRIADE S.P.A. - P. iva 07631370637
      </div>
      <div class="footer__separator">
        <div v-html="iconVector"></div>
      </div>
      <div class="footer__links">
        <ul>
          <li>
            <a
              href="https://www.jaked.com/it/terms-and-conditions"
              target="_blank"
              >Termini di servizio
            </a>
          </li>
          <li>
            <a
              href="https://www.iubenda.com/privacy-policy/58441074"
              target="_blank"
              >Privacy Policy</a
            >
          </li>
          <li>
            <a
              target="_blank"
              :href="'mailto:' + $store.state.campaign.support_email"
              >Support</a
            >
          </li>
          <li>
            <a target="_blank" href="/static/regolamento-loyalty-tribe.pdf"
              >Regolamento</a
            >
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>
<script>
import VectorIcon from "@/assets/svg/vector.svg";

export default {
  name: "footer-component",
  data() {
    return {};
  },
  computed: {
    iconVector() {
      return VectorIcon;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/mixins.scss";

footer {
  background-color: #000;
  color: #fff;
  padding-left: 1rem;
  padding-right: 1rem;

  .footer {
    &__container {
      width: 100%;
      min-height: 48px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      gap: 1rem;
      padding: 1rem 2rem;
      font-size: 14px;
      line-height: 24px;
      @include lg {
        flex-direction: row;
        max-width: 1440px;
        margin-left: auto;
        margin-right: auto;
        flex-wrap: wrap;
        padding: 0;
      }
    }

    &__copyright {
      text-align: center;
      @include lg {
        text-align: left;
      }
    }

    &__separator {
      color: var(--fe-action-primary);
    }

    &__links {
      ul {
        display: flex;
        flex: 1;
        gap: 1rem;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        margin: 0;
        @include lg {
          flex-direction: row;
        }
        color: var(--fe-base);

        li {
          a {
            color: var(--fe-base);
          }

          @include lg {
            &:not(:first-child):before {
              content: "|";
              margin-right: 1rem;
            }
          }
        }
      }
    }
  }
}
</style>
